<template>
  <form>
    <v-row class="py-0">
      <v-col class="py-0" cols="12" sm="12" md="11" lg="11">
        <form-edit
          :form="purchaseOtherPayment"
          ref="formEdit"
          :forwarders="forwarders"
          :listInvoice="listInvoice"
          :listBank="listBank"
          v-if="!edit"
        ></form-edit>
        <detail :id="id" :form="purchaseOtherPayment" v-if="edit"></detail>
      </v-col>
      <v-col cols="12" sm="12" md="1">
        <v-row class="py-0 mb-2" v-if="!edit">
          <v-col cols="12" class="py-0">
            <v-btn
              color="success"
              @click="updateItem"
              v-if="$rbac.can('purchase-other-payment.update')"
            >
              <v-icon>
                mdi-content-save
              </v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <v-row class="py-0 mb-2" v-if="edit">
          <v-col cols="12" class="py-0">
            <v-btn color="success" @click="printer">
              <v-icon>
                mdi-printer
              </v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <v-row
          class="py-0 mb-2"
          v-if="
            edit && purchaseOtherPayment.status === 'Outstanding' && !purchaseOtherPayment.hidden
          "
        >
          <v-col cols="12" class="py-0">
            <v-btn
              color="success"
              @click="editItem"
              v-if="$rbac.can('purchase-other-payment.update')"
            >
              <v-icon>
                mdi-pencil
              </v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <v-row
          class="py-0 mb-2"
          v-if="
            edit && purchaseOtherPayment.status === 'Outstanding' && !purchaseOtherPayment.hidden
          "
        >
          <v-col cols="12" class="py-0">
            <v-btn color="error" @click="dialogDelete">
              <v-icon>
                mdi-delete
              </v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <v-row class="py-0 mb-2" v-if="!edit">
          <v-col cols="12" class="py-0">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn color="error" v-on="on" @click="cancel">
                  <v-icon>
                    mdi-close
                  </v-icon>
                </v-btn>
              </template>
              <span>Close</span>
            </v-tooltip>
          </v-col>
        </v-row>
        <v-row class="py-0 mb-2" v-if="edit">
          <v-col cols="12" class="py-0">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn color="primary" v-on="on" @click="back">
                  <v-icon>
                    mdi-arrow-left
                  </v-icon>
                </v-btn>
              </template>
              <span>Back</span>
            </v-tooltip>
          </v-col>
        </v-row>
        <v-row class="py-0 mb-2" v-if="edit">
          <v-col cols="12" class="py-0">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn color="blue-grey" dark v-on="on" @click="dialogAuditHistory = true">
                  <v-icon>
                    mdi-history
                  </v-icon>
                </v-btn>
              </template>
              <span>History</span>
            </v-tooltip>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <dialog-delete
      :id="id"
      :dialog="dialog"
      :invoiceNumber="purchaseOtherPayment.invoiceNumber"
      title="Forwarder Payment"
      @deleteItem="deleteItem"
      @close="close"
    ></dialog-delete>

    <dialog-audit-history
      :dialog="dialogAuditHistory"
      entity-type="PurchaseOtherPayment"
      :entity-id="id"
      @close="dialogAuditHistory = false"
    ></dialog-audit-history>
  </form>
</template>

<script>
import Detail from "./DetailPurchaseOtherPayment";
import FormEdit from "./FormPurchaseOtherPayment";
import DialogDelete from "@/components/DialogDelete";
import DialogAuditHistory from "@/components/DialogAuditHistory.vue";

export default {
  name: "purchase-other-payment-view",
  components: {
    Detail,
    "form-edit": FormEdit,
    "dialog-delete": DialogDelete,
    DialogAuditHistory,
  },
  props: {
    id: {
      type: Number,
      default: () => undefined,
    },
  },
  data: () => ({
    edit: true,
    dialog: false,
    dialogAuditHistory: false,
    listBank: [],
    listInvoice: [],
    forwarders: [],
    purchaseOtherPayment: {},
  }),
  methods: {
    async getPurchaseOtherPayment() {
      this.$store
        .dispatch("purchaseOtherPayment/getById", this.id)
        .then(response => (this.purchaseOtherPayment = response.data));
      this.getBanks();
      this.getListInvoice(this.id);
      this.getForwarders(), this.$store.dispatch("chartOfAccount/getOtherAccounts");
    },
    getListInvoice(id) {
      this.$store.dispatch("purchaseOtherPayment/getListInvoiceById", id).then(response => {
        this.listInvoice = response.data;
      });
    },
    getBanks() {
      this.$store.dispatch("chartOfAccount/getBanks").then(response => {
        this.listBanks = response.data;
      });
    },
    getForwarders() {
      this.$store.dispatch("external/getForwarders").then(response => {
        this.forwarders = response.data;
      });
    },
    back() {
      this.$router.go(-1);
    },
    editItem() {
      this.edit = false;
    },
    updateItem() {
      this.$refs.formEdit.update();
    },
    dialogDelete() {
      this.dialog = true;
    },
    deleteItem(id) {
      this.$store.dispatch("purchaseOtherPayment/delete", id);
    },
    close() {
      this.dialog = false;
    },
    cancel() {
      this.getPurchaseOtherPayment();
      this.edit = true;
    },
    printer() {
      this.$router.push({ name: "Payment Voucher Forwarder", params: { id: this.id } });
    },
  },
  mounted() {
    this.getPurchaseOtherPayment();
  },
};
</script>

<style></style>
